var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"component-connection-practice-notes-dialog"},[_c('v-dialog',{attrs:{"max-width":"1280","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('ConnectionPracticeNotes',{attrs:{"embedded":""},on:{"close":_vm.onClose}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }